import {
  getRestaurantProfile,
  mergeRemoteBranchIntoProfilePreservingLocalPreferences,
  saveRestaurantProfile,
} from "../local/restaurantProfile";
import { getBranchPublicProfile } from "./companyAdminService";
import { hydrateSharedOperationalStateToLocal } from "./operationalStateService";
import { hydrateBranchPromotionsToLocal } from "./promotionsService";

const buildOperationalFallbackState = () => ({
  mesasActivas: [],
  pedidosHistoricos: [],
});

const buildEmptyBootstrapReport = (branchId = "") => ({
  branchId,
  updatedProfile: null,
  synced: {
    profile: false,
    promotions: false,
    operationalState: false,
  },
  issues: [],
});

const normalizeIssue = (scope, error) => ({
  scope,
  message:
    error instanceof Error
      ? error.message
      : String(error || "No se pudo completar la sincronizacion remota."),
});

export const hydrateCriticalBranchStateToLocal = async (
  restaurant,
  options = {}
) => {
  const branchId = String(restaurant?.id || "").trim();

  if (!branchId) {
    return buildEmptyBootstrapReport();
  }

  const localProfile =
    options.localProfile && typeof options.localProfile === "object"
      ? options.localProfile
      : getRestaurantProfile(restaurant);
  const report = buildEmptyBootstrapReport(branchId);

  const [remoteProfileResult, promotionsResult, operationalStateResult] =
    await Promise.allSettled([
      getBranchPublicProfile(branchId),
      hydrateBranchPromotionsToLocal(restaurant, branchId),
      hydrateSharedOperationalStateToLocal(
        restaurant,
        buildOperationalFallbackState
      ),
    ]);

  if (remoteProfileResult.status === "fulfilled") {
    report.updatedProfile = saveRestaurantProfile(
      restaurant,
      mergeRemoteBranchIntoProfilePreservingLocalPreferences(
        localProfile,
        remoteProfileResult.value
      )
    );
    report.synced.profile = true;
  } else {
    report.issues.push(normalizeIssue("profile", remoteProfileResult.reason));
  }

  if (promotionsResult.status === "fulfilled") {
    report.synced.promotions = true;
  } else {
    report.issues.push(normalizeIssue("promotions", promotionsResult.reason));
  }

  if (operationalStateResult.status === "fulfilled") {
    report.synced.operationalState = Boolean(
      operationalStateResult.value?.supported
    );
  } else {
    report.issues.push(
      normalizeIssue("operationalState", operationalStateResult.reason)
    );
  }

  return report;
};
